import { SubmitOrderRequest as _SubmitOrderRequest } from '@models/api-orders.models';

export type Address = {
    fullName: string;
    streetAddress: string;
    zipCode: string;
    city: string;
    phoneNumber: string;
};

export type AddressWithCvr = Address & {
    cvrNumber: string;
};

export type BusinessAddress = {
    companyName: string;
    attentionTo: string;
    streetAddress: string;
    zipCode: string;
    city: string;
};

export type ParcelShopAddress = {
    provider: string;
    id: string;
    companyName: string;
    streetAddress: string;
    zipCode: string;
    city: string;
};

export type PickupInStoreAddress = {
    id: string;
    storeName: string;
    streetAddress: string;
    zipCode: string;
    city: string;
};

export enum DeliveryMethodType {
    PrivateAddress = 'Private Address',
    BusinessAddress = 'Business Address',
    CollectInShop = 'Collect In Shop',
    ParcelShop = 'Parcel Shop',
    Burd = 'Burd',
    Email = 'Email'
}

export type CheckoutData = {
    basketId: string;
    billingAddress: AddressWithCvr;
    isDifferentAddress: boolean;
    deliveryMethod: string;
    deliveryMethodType?: DeliveryMethodType;
    privateDeliveryAddress: Address;
    businessDeliveryAddress: BusinessAddress;
    deliveryParcelShopAddress: ParcelShopAddress;
    pickupInStoreAddress: PickupInStoreAddress;
    paymentMethod: string;
    userEmail: string;
    subscribeToNewsletter: boolean;
    updateUserProfile?: boolean;
    newUserBirthDate?: string;
    orderFromStoreId?: string;
};

export type SubmitOrderRequest = _SubmitOrderRequest;

export type GtmTrackingData = Pick<
    SubmitOrderRequest,
    'gtmTrackingClientId' | 'gtmTrackingSessionId' | 'gtmTrackingUserId'
>;
